import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const IntroPlacaRollo = () => {
  return (
    <section id="rollo-autoadhesivo" className="about-service pb-0">
      <div className="container">
        <div className="row align-items-center mt-n1-9">
          <div className="col-lg-6 mt-1-9">
            <div className="pe-lg-6 pe-xl-15">
              <div className="mb-1-4">
                <span className="badge bg-primary text-white fs-6 px-4 py-3 rounded-pill">Nuevo Producto</span>
              </div>
              <div className="title-style2 mb-2-2 wow fadeIn" data-wow-delay="200ms">
                <span className="text-primary font-weight-800 text-uppercase mb-2 d-block">
                  Instalación instantánea sin obra
                </span>
                <h2 className="h1">Placas en Rollo Autoadhesivas</h2>
              </div>
              <p className="mb-1-9">
                Las placas en rollo autoadhesivas representan la evolución del revestimiento decorativo. 
                Diseñadas para quienes buscan resultados profesionales sin complicaciones ni instaladores.
              </p>
              <p className="mb-1-9">
                Las láminas en rollo con acabado tipo mármol, le darán un aspecto sofisticado y lujo a 
                tus muros sin necesidad de instalación compleja. Son una gran opción en la decoración de 
                interiores debido a sus numerosos beneficios y características particulares.
              </p>
              <p className="mb-2-9">
                Su sistema autoadherible cuenta con adhesivo de alta calidad que se fija instantáneamente 
                sin herramientas ni perforaciones. Son flexibles y ultraligeras, adaptándose perfectamente 
                a superficies curvas, esquinas y espacios irregulares. No requieren instaladores profesionales, 
                tú mismo puedes instalarlas en minutos.
              </p>
              <div className="w-xl-90 w-xxl-100 mb-6">
                <BannerNoInstalacion />
              </div>
            </div>
          </div>
          
          <div className="col-lg-6 mt-1-9 mb-20">
            <div className="wow fadeIn" data-wow-delay="400ms">
              <img 
                src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-placa-tipo-marmol/rollo-marmol/rollo-pvc-2.jpeg`}
                alt="Placa tipo mármol en rollo autoadhesiva" 
                className="rounded"
                style={{ width: '100%', maxWidth: '550px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroPlacaRollo;